import React from "react"
import classNames from "classnames"
import { ShopPaymentPoint } from "../../libs/api/backend/src"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../hooks/enterprise"
import { useShopGetOne, useShopId } from "../../hooks/shop"
import { useShopSalePointId } from "../../hooks/shopSalePoint"
import {
  useShopPaymentPointFindAllForSalePointID,
  useShopPaymentPointId,
} from "../../hooks/shopPaymentPoint"
import ShopPaymentPointList from "../ShopPaymentPoint/ShopPaymentPointList"
import CheckoutMainBySelectedPaymentMethod from "./CheckoutMainBySelectedPaymentMethod"

export default function CheckoutPaymentMethod() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()
  const shopPaymentPointId = useShopPaymentPointId()

  // Fetch
  const { isLoading: isLoadingEnterprise, isError: isErrorEnterprise } =
    useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )
  const {
    shopPaymentPoints,
    isLoading: isLoadingShopPaymentPoints,
    isError: isErrorShopPaymentPoints,
  } = useShopPaymentPointFindAllForSalePointID(enterpriseId, shopSalePointId)

  if (
    isLoadingEnterprise ||
    isErrorEnterprise ||
    isLoadingShop ||
    isErrorShop ||
    isLoadingShopPaymentPoints ||
    isErrorShopPaymentPoints
  ) {
    return null
  }

  let selectedPaymentMethod: ShopPaymentPoint | null = null

  if (shopPaymentPoints && shopPaymentPoints.length) {
    for (let i = 0; i < shopPaymentPoints.length; i++) {
      if (shopPaymentPointId === shopPaymentPoints[i].id) {
        selectedPaymentMethod = shopPaymentPoints[i]
        break
      }
    }
  }

  return (
    <div className="px-4 py-4 sm:px-6">
      <div
        className={classNames("flex flex-col sm:flex-row", {
          "items-center": !shopPaymentPointId,
        })}
      >
        <div className="mb-8 w-full sm:mb-0 sm:w-56">
          <ShopPaymentPointList />
        </div>

        {/* Sums & input */}
        <div className="flex-1 sm:pl-6">
          {!shopPaymentPointId ? (
            <p className="my-8 text-center text-xl font-bold text-gray-700">
              Выберите способ оплаты
            </p>
          ) : (
            <CheckoutMainBySelectedPaymentMethod
              selectedPaymentMethod={selectedPaymentMethod}
            />
          )}
        </div>
      </div>
    </div>
  )
}
